import styled from "styled-components";
import theme from "../../theme/ThemeProvider.styled";

const PageTitle = styled.h1`
font-size: 3rem;
@media only screen and (min-width: ${theme.smallTablet}) {
    font-size: 4.8rem;
}
margin-bottom: 2rem;
`;

export default PageTitle;
